export default __webpack_public_path__ + "static/media/separator_line_and_text.59c15929.svg";